import React from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { CustomFields, filterCustomFieldsConfig } from "../../fields/CustomFields";

export const MiscInformationSectionCmp = ({ record, customFieldsUI, formik }) => {
  const resourceType = formik.form.values.metadata.resource_type;
  const config = filterCustomFieldsConfig(
    customFieldsUI,
    "miscellaneous",
    resourceType
  );
  return <CustomFields record={record} config={config} resourceType={resourceType} />;
};

MiscInformationSectionCmp.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
  formik: PropTypes.object.isRequired,
};

export const MiscInformationSection = (props) => {
  return (
    <Field>
      {(formik) => <MiscInformationSectionCmp formik={formik} {...props} />}
    </Field>
  );
};

MiscInformationSection.propsTypes = {
  record: PropTypes.object.isRequired,
  customFieldsUI: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.string.isRequired,
      displaySection: PropTypes.bool,
      fields: PropTypes.arrayOf(
        PropTypes.shape({
          field: PropTypes.string.isRequired,
          ui_widget: PropTypes.string.isRequired,
          props: PropTypes.object,
        })
      ),
    })
  ).isRequired,
};

MiscInformationSection.defaultProps = {};
